// extracted by mini-css-extract-plugin
export var circle = "styles-module--circle--01588";
export var circle1 = "styles-module--circle1--d40c8";
export var circle2 = "styles-module--circle2--c5e08";
export var circle3 = "styles-module--circle3--bcfe7";
export var circle4 = "styles-module--circle4--132da";
export var circle5 = "styles-module--circle5--a5025";